<template>
<section v-if="author">
    <div class="author-metadata">
        <div class="row title">
            <div class="col-md-8 col-sm-6 col-4 pl-0">
                <h5>
                    {{ author.seq + 1 }}.

                    <!-- TODO: -->
                    <template v-if="author.author_type == 'I'">
                        <span v-if="author.first_name != null || author.last_name != null" style="font-weight: bold; font-size: 20px;">{{ author.first_name }} {{ author.last_name }}</span>

                        <span v-else style="font-weight: bold; font-size: 20px;">New individual author</span>
                    </template>

                    <!-- TODO: -->
                    <template v-else-if="author.author_type == 'G'">
                        <span v-if="author.group_name != null" style="font-weight: bold; font-size: 20px;">{{ author.group_name }}</span>

                        <span v-else style="font-weight: bold; font-size: 20px;">New group author</span>
                    </template>
                </h5>
            </div>
            <div class="col-md-4 col-sm-6 col-8 actions">
                <a v-bind:class="{ deactive: disabled }" v-on:click="$modal.show('article-authors-reorder')">
                    <i class="fa fa-arrows-alt"></i> Reorder authors
                </a> | <a v-bind:class="{ deactive: disabled }" v-on:click="removeAuthor">
                    <i class="fa fa-trash-alt"></i> Delete
                </a>
            </div>
        </div>

        <div>
            <!-- AUTHOR SECTION STARTS -->
            <section>
                <div class="row">
                    <div class="col-md-12 content-padding keyword">
                        <p class="mb-1">
                            Please select the most appropriate author type.
                        </p>

                        <label style="margin-right: 24px;" v-bind:class="{ deactive: disabled }">
                            <input type="radio" value="I" v-bind:id="'author-type-individual-' + author.author_id" v-model="author.author_type" />
                            <b>Individual author</b>
                            <span class="radio"></span>
                        </label>

                        <label v-bind:class="{ deactive: disabled }">
                            <input type="radio" value="G" v-on:change="author.primary_contact = null" v-bind:id="'author-type-group-' + author.author_id" v-model="author.author_type" />
                            <b>
                                Collaborative (group) Author
                                <jmir-popover position="right">
                                    <i class="fa fa-question-circle tooltip-target b3"></i>
                                    <template slot="content">
                                        <p>
                                            A group of authors (contributors) credited under one
                                            name, either as a collaboration or when an organization,
                                            institution, or corporation is the value. If authors
                                            wish to acknowledge a group that is not a co-author,
                                            groups can be mentioned using the field “Written on
                                            behalf of”, in which case the group will appear in the
                                            affiliation footnote of the respective individual
                                            author, but the article will not be indexed with the
                                            group as co-value. For individual members of the group
                                            to be listed in PubMed as contributors, enter
                                            contributors below. Contributors can also be mentioned
                                            in the Acknowledgements section of the manuscript.
                                        </p>
                                    </template>
                                </jmir-popover>
                            </b>
                            <span class="radio"></span>
                        </label>

                        <hr />

                        <form autocomplete="off">
                            <!-- individual author -->
                            <div class="row" style="margin: 0 auto" v-if="author.author_type == 'I'">
                                <label class="col-md-12 pl-0" v-bind:class="{ deactive: disabled }">
                                    <input type="radio" :value="1" v-model="author.primary_contact" v-on:click="
        adjustCorrespondingDetails(orderedAuthors, index)
      " />
                                    Corresponding author for this submission
                                    <span class="radio"></span>
                                    <jmir-popover position="right">
                                        <i class="fa fa-question-circle tooltip-target b3"></i>
                                        <template slot="content">
                                            <p>
                                                Indicates whether the named contributor (e.g., an
                                                author should receive correspondence, i.e., the
                                                attribute is set to "yes"; if the contributor is a
                                                corresponding value.
                                            </p>
                                        </template>
                                    </jmir-popover>
                                    <span>
                                        Note: Only one corresponding author can be assigned. If
                                        you wish to change the corresponding author, please select
                                        another author as the corresponding value.
                                    </span>
                                </label>

                                <!-- first name -->
                                <div class="form-group col-md-4">
                                    <label class="asterik">First name</label>
                                    <input required=" required" v-model="author.first_name" v-bind:name="'first name of author ' + (index + 1) + ''" v-validate="'required'" />
                                    <span class="text-error">

                                    </span>
                                    <small style="color: red;" v-if="hasError(index + '.' + 'first_name')">{{ hasError(index + "." + "first_name", true) }}</small>
                                </div>

                                <!-- middle name -->
                                <div class="form-group col-md-4">
                                    <label>Middle name</label>
                                    <input type="text" class="form-control" required="required" v-model="author.middle_name" v-bind:class="{ deactive: disabled }" />
                                </div>

                                <!-- last name -->
                                <div class="form-group col-md-4">
                                    <label class="asterik">Last name</label>
                                    <input v-bind:id="'' + 'last name of author ' + (index + 1) + ''" type="text" class="form-control" required="required" v-model="author.last_name" />
                                    <span class="text-error">

                                    </span>
                                    <small style="color: red;" v-if="hasError(index + '.' + 'last_name')">{{ hasError(index + "." + "last_name", true) }}</small>
                                </div>

                                <!-- suffix -->
                                <div class="form-group col-md-4">
                                    <label>
                                        Suffix
                                        <jmir-popover position="right">
                                            <i class="fa fa-question-circle tooltip-target b3"></i>
                                            <template slot="content">
                                                <p>
                                                    Qualifiers that follow a person's name, for example
                                                    Sr, Jr, III, 3rd, etc
                                                </p>
                                            </template>
                                        </jmir-popover>
                                    </label>
                                    <input type="text" class="form-control" required="required" v-model="author.suffix" v-bind:class="{ deactive: disabled }" />
                                </div>

                                <!-- email -->
                                <div class="form-group col-md-4 mt-2">
                                    <label class="asterik">Email</label>
                                    <input v-bind:id="'' + 'email of author ' + (index + 1) + ''" type="email" class="form-control" required="required" v-bind:name="'email of author ' + (index + 1) + ''" v-model="author.email" />
                                    <span class="text-error">

                                    </span>
                                    <small style="color: red;" v-if="hasError(index + '.' + 'email')">{{ hasError(index + "." + "email", true) }}</small>
                                </div>

                                <!-- orcid -->
                                <div class="form-group col-md-4">
                                    <label>
                                        <img style="width:18px; margin-right:3px;" src="https://asset.jmir.pub/assets/static/images/orcidGreen.svg" />ORCiD
                                        <jmir-popover position="left">
                                            <i class="fa fa-question-circle tooltip-target b3"></i>
                                            <template slot="content">
                                                <p>
                                                    ORCID provides a persistent digital identifier that
                                                    distinguishes you from every other researcher and,
                                                    through integration in key research workflows such
                                                    as manuscript and grant submission, supports
                                                    automated linkages between you and your professional
                                                    activities ensuring that your work is recognized.
                                                    <br />Sign up for an ORCID iD at
                                                    <a href="https://orcid.org/register">https://orcid.org/register</a>
                                                </p>
                                            </template>
                                        </jmir-popover>
                                    </label>
                                    <input type="text" class="form-control" v-model="author.orcid" v-bind:name="'ORCID code of author ' + (index + 1) + ''" v-bind:class="{ deactive: disabled }" />
                                    <span class="text-error">

                                    </span>
                                </div>

                                <!-- role -->
                                <div class="form-group col-md-6">
                                    <label>
                                        Role
                                        <jmir-popover position="right">
                                            <i class="fa fa-question-circle tooltip-target b3"></i>
                                            <template slot="content">
                                                <p>
                                                    “The title or role of a contributor, for example,
                                                    Chief Scientist or Research Associate”.
                                                </p>
                                            </template>
                                        </jmir-popover>
                                    </label>
                                    <input type="text" class="form-control" v-model="author.role" v-bind:class="{ deactive: disabled }" />
                                </div>

                                <!-- twitter handle -->
                                <div class="form-group col-md-6">
                                    <label>
                                        Twitter handle
                                        <jmir-popover position="right">
                                            <i class="fa fa-question-circle tooltip-target b3"></i>
                                            <template slot="content">
                                                <p>Some text</p>
                                            </template>
                                        </jmir-popover>
                                    </label>
                                    <input @keydown="checkTwitterInput(event)" type="text" class="form-control" v-model="author.twitter_handle" v-bind:class="{ deactive: disabled }" />
                                </div>

                                <!-- degrees -->
                                <div class="form-group col-md-12">
                                    <label>
                                        Degrees
                                        <jmir-popover position="right">
                                            <i class="fa fa-question-circle tooltip-target b3"></i>
                                            <template slot="content">
                                                <p>
                                                    “Academic titles or professional certifications,
                                                    such as MD or PhD. Designations such as student,
                                                    candidate, and professor are not permitted.”
                                                </p>
                                            </template>
                                        </jmir-popover>
                                        <span>
                                            Please add author degrees in the order they should
                                            appear. Click and drag degrees to modify the order.
                                        </span>
                                    </label>

                                    <div class="multiselect-wrapper" v-bind:class="{ deactive: disabled }">
                                        <div class="v-select vs--searchable vs--open display-multiselect">
                                            <draggable v-model="author.degrees" @start="dragging = true" @end="dragging = false" v-if="author.degrees && authorDegree != ''">
                                                <ul class="vs__selected vs__deselect selected-pills" v-for="(authorDegree,
            authorDegreeIndex) in author.degrees" v-bind:key="authorDegreeIndex">
                                                    <li>
                                                        {{ authorDegree }}
                                                        <button v-on:click="
                  deselectDegree(
                    author.degrees,
                    authorDegreeIndex
                  )
                " type="button" aria-label="deselect option" class="vs__deselect">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                                                                <path
                                                                    d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" />
                                                            </svg>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </draggable>
                                        </div>
                                        <v-select label="authorDegree" multiple taggable push-tags="true" :options="degrees" v-model="author.degrees" v-bind:class="{ deactive: disabled }" />
                                    </div>
                                    <jselect :options="countries" :label="'country'" :key="'name'" :disabled="disabled" :default-option="false"></jselect>

                                </div>
                            </div>

                            <!-- group author -->
                            <div class="row content-padding" v-else-if="author.author_type == 'G'">
                                <!-- group name -->
                                <div class="form-group col-md-6">
                                    <label class="asterik">Group name</label>
                                    <input type="text" class="form-control" required="required" v-model="author.group_name" />
                                    <span class="text-error">

                                    </span>
                                    <small style="color: red;" v-if="hasError(index + '.' + 'group_name')">{{ hasError(index + "." + "group_name", true) }}</small>
                                </div>

                                <!-- email -->
                                <div class="form-group col-md-6">
                                    <label class="asterik">Email</label>
                                    <input type="text" class="form-control" required="required" v-model="author.email" />
                                    <span class="text-error">

                                    </span>
                                    <small style="color: red;" v-if="hasError(index + '.' + 'email')">{{ hasError(index + "." + "email", true) }}</small>
                                </div>
                            </div>

                            <!-- equal contribution footnote -->
                            <div class="form-group col-md-12">
                                <label>
                                    Equal contribution footnote
                                    <jmir-popover position="right">
                                        <i class="fa fa-question-circle tooltip-target b3"></i>
                                        <template slot="content">
                                            <p>
                                                Indicates whether all contributors contributed
                                                equally. If the contributor whom this attribute
                                                modifies contributed equally with all other
                                                contributors, this attribute should be set to "yes";
                                                if his/her contribution was greater or lesser, then
                                                this attribute should be set to "no". Usage notes:
                                                This attribute - defined by the NLM - is unfortunately
                                                quite confusing and ambiguous, because whether "This
                                                contributor did not participate equally with all other
                                                contributors." indicates a greater or a lesser
                                                contribution remains unclear. We recommend to select
                                                "Unspecified" and to provide a narrative in the
                                                textbox "Authors' Contributions" instead. ONLY use
                                                this attribute in exceptional circumstances if you
                                                want to render an equal contribution footnote for the
                                                main authors, e.g. the FIRST TWO AUTHORS or THE FIRST
                                                AND THE LAST AUTHOR, by checking "YES" for these
                                                authors. JMIR will render the footnote "These authors
                                                contributed equally to this work" for the authors
                                                where this attribute is set to "YES", implying that
                                                the contributions of the authors set to \"NO\" has
                                                been lesser
                                            </p>
                                        </template>
                                    </jmir-popover>
                                    <span>
                                        Selected authors receive a footnote declaring “These
                                        authors contributed equally”. Equal contribution can be
                                        selected for a select number of authors or all authors.
                                    </span>
                                </label>
                                <select class="form-control dropdown" v-model="author.equal_contrib" v-bind:class="{ deactive: disabled }">
                                    <option value>Unspecified (no footnote) </option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>

                            <!-- written on behalf of -->
                            <div class="form-group col-md-12">
                                <label>
                                    Written on behalf of
                                    <jmir-popover position="right">
                                        <i class="fa fa-question-circle tooltip-target b3"></i>
                                        <template slot="content">
                                            <p>
                                                When a contributor has written or edited a piece of
                                                work on behalf of an organization or group, the
                                                contributor is acting as a representative of the
                                                organization. This group or organization the author is
                                                representing may or may not be the author’s usual
                                                affiliation. For example, a physician affiliated with
                                                St. Luke’s Hospital may be writing on behalf of the
                                                Multiple Sclerosis Collaborative Research Group. If an
                                                author is writing on behalf of a group that is also
                                                considered an author, please add this group as a group
                                                author by adding a collaborative (group) value.
                                            </p>
                                        </template>
                                    </jmir-popover>
                                    <span>
                                        If this author is writing on behalf of a group,
                                        organization, or institution, enter the name here. If a
                                        group entered here is also considered an author, please
                                        add it as a group value.
                                    </span>
                                </label>
                                <input type="text" class="form-control" required="required" v-model="author.on_behalf" v-bind:class="{ deactive: disabled }" />
                            </div>

                            <!-- colloborators -->
                            <div class="row content-padding pb-0" v-if="author.author_type == 'G'">
                                <div class="form-group col-md-12">
                                    <label>
                                        Collaborators
                                        <jmir-popover position="right">
                                            <i class="fa fa-question-circle tooltip-target b3"></i>
                                            <template slot="content">
                                                <p>
                                                    Collaborators for a group author should be
                                                    acknowledged. These collaborators will appear in an
                                                    expandable field under the group author in PubMed.
                                                    Examples include members of a research group or
                                                    participants of a consensus workshop.
                                                </p>
                                            </template>
                                        </jmir-popover>
                                    </label>

                                    <div class="row px-3 mx-1 mt-2 pb-2 border" style="background-color: #f9f9f9;" v-for="(collaborator, collaboratorIndex) in author.collaborators">
                                        <div class="form-group col-md-4">
                                            <label for="fname">First Name</label>
                                            <input type="text" class="form-control" v-model="collaborator.firstName" v-bind:class="{ deactive: disabled }" />
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label for="fname">Middle Name</label>
                                            <input type="text" class="form-control" required="required" v-model="collaborator.middleName" v-bind:class="{ deactive: disabled }" />
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label for="fname">Last Name</label>
                                            <input type="text" class="form-control" v-model="collaborator.lastName" v-bind:class="{ deactive: disabled }" />
                                        </div>

                                        <!-- remove collaborator -->
                                        <a class="small" href="javascript:;" v-bind:class="{ deactive: disabled }" v-on:click="removeCollaborator(collaborator, collaboratorIndex)">
                                            <i class="fa fa-minus"></i>
                                            Remove collaborator
                                        </a>
                                    </div>

                                    <!-- add collaborator -->
                                    <div class="subfield add">
                                        <a v-on:click="addCollaborator" v-bind:class="{ deactive: disabled }">
                                            <i class="fa fa-plus"></i> Add collaborator
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <!-- AUTHOR SECTION ENDS -->

            <!-- add affiliation -->
            <div class="row">
                <div class="col-md-12 content-padding">
                    <button type="button" class="btn-custom btn-custom-light-green btn-block" v-on:click="addAuthorAffiliation()" v-bind:class="{ deactive: disabled }">
                        <i class="fa fa-plus" style="color: #629F36;"></i> Add affiliation
                    </button>
                </div>
            </div>

            <hr />
            <!-- save button -->
            <div class="final-save-button" v-if="!disabled">
                <button type="button" class="btn-custom btn-custom-green mb-3" href="javascript:;" v-on:click="saveAuthor()">
                    <span class="mt-1" v-bind:class="{ 'spinner-grow spinner-grow-sm': authorLoading }" style="float: left; color: white;" role="status" aria-hidden="true"></span>
                    Save author
                </button>
            </div>

            <!-- errors 1 -->
            <small style="color: red;" v-if="hasError('*.authors')">
                {{ hasError("*.authors", true) }}
            </small>
        </div>
    </div>
</section>
</template>

<script>
export default {
    props: ["author", "article", "index"],
    data: () => {
        return {
            degrees: [],
            countries: [],
            authorLoading: false
        };
    },
    methods: {
        hasError: () => {},
        returnAffiliationName: function(affiliation) {
            var a = "";

            if (affiliation.address.institution_line_1) {
                a += affiliation.address.institution_line_1;
            }

            if (affiliation.address.institution_line_2) {
                a += affiliation.address.institution_line_2;
            }

            if (affiliation.address.institution_line_3) {
                a += affiliation.address.institution_line_3;
            }

            a += ",";

            if (affiliation.address.city) {
                a += affiliation.address.city;
            }

            a += ",";

            if (affiliation.address.country && affiliation.address.country.name) {
                a += affiliation.address.country.name;
            } else {
                a += affiliation.address.country;
            }

            a += " " + affiliation.aff_id.toString();

            return a;
        },
        async getOptions() {
            let [degrees, countries] = await Promise.all([
                axios.get('/api/degrees'),
                axios.get('/api/countries')
            ]);

            this.degrees = degrees.data;
            this.countries = countries.data;

            this.$forceUpdate();
        },
        addCollaborator() {
            let vm = this;

            if (typeof vm.author.collaborators === 'undefined') {
                vm.author.collaborators = [];
            }

            vm.author.collaborators.push({
                first_name: null,
                middle_name: null,
                last_name: null,
            });

            vm.$forceUpdate();
        },
        removeCollaborator(collaborator, collaboratorIndex) {
            let vm = this;

            vm.author.collaborators.splice(collaboratorIndex, 1);

            vm.$forceUpdate();
        },
        saveAuthor: async function() {
            let vm = this;

            vm.authorLoading = true;

            let repsonse = await axios.post('/api/articles/' + vm.article.article_id + '/authors', {
                author: vm.author,
                authorIndex: vm.index
            });

            errors = [];
            success = true;

            this.authorLoading = false;

            if (!vm.author.author_id) {
                vm.author = response.data;
            }

            $forceUpdate();
        },
        removeAuthor: function(author, index) {
            var vm = this;

            var authorId = author.author_id;

            if (vm.article.authors.length == 1) {
                vm.$modal.show('dialog', {
                    title: 'Error',
                    text: 'You must have at least <strong>1 author</strong> on this article',
                    buttons: [{
                        title: 'Close'
                    }]
                });

                return;
            }

            if (author.primary_contact == 1) {
                vm.$modal.show('dialog', {
                    title: 'Error',
                    text: 'Cannot delete the corresponding author. Please select a new corresponding author and try again.',
                    buttons: [{
                        title: 'Close'
                    }]
                });

                return;
            }

            vm.$modal.show('dialog', {
                title: 'Delete Author',
                text: 'Are you sure you want to delete this author?',
                buttons: [{
                        title: 'Cancel',
                        default: true
                    },
                    {
                        title: vm.authorDeleteDialogButton,
                        handler: function() {
                            vm.authorDeleteDialogButton = `<div class="spinner-grow text-danger" role="status"><span class="sr-only">Loading...</span></div>`;

                            if (vm.article.authors[index].author_id !== undefined) {
                                //
                                axios.delete('/api/articles/' + vm.articleId.user_id + '/authors', {
                                        data: {
                                            author: author
                                        }
                                    })
                                    .then(function(response) {
                                        if (authorId > -1) {
                                            vm.article.authors.splice(index, 1);
                                        }
                                    });
                            } else {
                                vm.article.authors.splice(index, 1);
                            }

                            vm.authorDeleteDialogButton = 'Delete'
                            vm.$modal.hide('dialog')

                            vm.showToast('Author successfully deleted');
                            vm.article.authors.splice(index, 1);
                        }
                    }
                ]
            });
        },
    },
    created() {
        this.getOptions();
    }
};
</script>

<style lang="css" scoped></style>
